import { InputFragment } from '../formikInput/input.fragment';

import { InputWithConditionalInputsFragment } from './inputWithConditionalInputs.fragment';

export const isSimpleInput = (
  input: InputFragment | InputWithConditionalInputsFragment
): input is InputFragment => 'type' in input;
